import React, { useEffect, useRef, useState } from "react";
import Logo from "../../logo/Logo";
import Usermenu from "../../menu/Usermenu";
import SubMenu from "../../menu/SubMenu";
import "./userheader.css";
import { useLocation, useNavigate } from "react-router-dom";
import TopHeader from "../topheader/TopHeader";
import { Bars3BottomLeftIcon } from "@heroicons/react/16/solid";
import { AnimatePresence } from "motion/react";
import ResponsivesideBar from "../responsivemenu/Responsivemenu";
import { FaXmark } from "react-icons/fa6";
import { handleTopScroll } from "../../../common/function/ScroolTop";
const UserHeader = () => {
  const [menuStatus, setMenuStatus] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const closeref = useRef();

  const isCarrer = location.pathname.includes("/careers");
  const isFacilities = location.pathname.includes("/facilities");
  const isNewssection = location.pathname.includes("/newssection");
  const isExpertise = location.pathname.includes("/expertise");
  const isAllproduct = location.pathname.includes("/allproduct");

  useEffect(() => {
    let outsideclick = (e) => {
      if (!closeref?.current?.contains(e.target)) {
        setMenuStatus(false);
      }
    };
    document.addEventListener("mousedown", outsideclick);
  }, []);

  const handleGoBack = () => {
    navigate("/#home");

    handleTopScroll();
  };

  return (
    <>
      <TopHeader />
      <div className="backdrop-blur-xl sticky w-full top-0 z-[200]  bg-opacity-80 ">
        <div className="userheader-box container lg:max-w-[1230px] md:px-4 sm:px-4 max-sm:px-4 py-0 lg:py-0 md:py-0 sm:py-4 max-sm:py-2 ">
          <div className="w-1/3 min-lg:w-1/3 lg:w-1/3  md:w-10/12 sm:w-10/12 max-sm:w-10/12 ">
            <Logo />
          </div>
          <div className="w-2/3 flex items-center  bg-white  text-black px-4 py-1.5 shadow-lg drop-shadow-lg rounded-3xl min-lg:flex lg:flex max-md:hidden md:hidden sm:hidden max-sm:hidden ">
            <Usermenu />

            <SubMenu closeref={closeref} />
          </div>
          <div className="w-1/2 hidden  items-center justify-end  lg:hidden  sm:flex md:flex max-sm:flex  md:w-2/12 sm:w-2/12 max-sm:w-2/12  z-[200000000] ">
            {!menuStatus ? (
              <Bars3BottomLeftIcon
                onClick={() => setMenuStatus(!menuStatus)}
                className="w-10 h-10  text-black"
                style={{ cursor: "pointer" }}
              />
            ) : (
              <FaXmark
                onClick={() => setMenuStatus(!menuStatus)}
                className="w-10 h-10  text-black"
                style={{ cursor: "pointer" }}
              />
            )}
          </div>
          <div className="lg:hidden">
            <AnimatePresence mode="wait">
              {menuStatus && (
                <div ref={closeref}>
                  <ResponsivesideBar setMenuStatus={setMenuStatus} />
                </div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserHeader;
